'use client';

import { APIProvider as GoogleMapsApiProvider } from '@vis.gl/react-google-maps';
import type React from 'react';
import {
  browserCookieIdExperiments,
  userIdExperiments
} from '~/constants/dealership/experiments';
import { googleMapsApiKey } from '~/constants/environment';
import {
  DeviceContextProvider,
  type OwnProps as DeviceContextProps
} from '~/context/common/DeviceContext';
import ExperimentProvider, {
  type PropsFromServer as ExperimentContextProps
} from '~/context/common/ExperimentProvider';
import {
  StaticContextProvider as CommonStaticContextProvider,
  type OwnProps as CommonStaticContextProps
} from '~/context/common/StaticContext';
import {
  OwnProps as StaticContextProps,
  StaticContextProvider
} from '~/context/dealership/StaticContext';
import { ModalContextProvider } from './ModalContext';

export type OwnProps = React.PropsWithChildren<{
  forCommonStaticContext: CommonStaticContextProps;
  forDeviceContext?: DeviceContextProps;
  forExperimentContext?: ExperimentContextProps;
  forStaticContext: StaticContextProps;
}>;

export default function DealershipProviders({
  forCommonStaticContext,
  forDeviceContext = {} as DeviceContextProps,
  forExperimentContext,
  forStaticContext,
  children
}: OwnProps) {
  const content = forExperimentContext ? (
    <ExperimentProvider
      {...forExperimentContext}
      browserCookieIdExperiments={browserCookieIdExperiments}
      userIdExperiments={userIdExperiments}
    >
      {children}
    </ExperimentProvider>
  ) : (
    children
  );

  return (
    <GoogleMapsApiProvider apiKey={googleMapsApiKey}>
      <DeviceContextProvider {...forDeviceContext}>
        <CommonStaticContextProvider {...forCommonStaticContext}>
          <StaticContextProvider {...forStaticContext}>
            <ModalContextProvider>{content}</ModalContextProvider>
          </StaticContextProvider>
        </CommonStaticContextProvider>
      </DeviceContextProvider>
    </GoogleMapsApiProvider>
  );
}
